// FETCH ALL CUTTING INWARD_DC
export const FETCH_CUTTING_DC_INWARD_MASTER_REQUEST = 'FETCH_CUTTING_DC_INWARD_MASTER_REQUEST';
export const FETCH_CUTTING_DC_INWARD_MASTER_SUCCESS = 'FETCH_CUTTING_DC_INWARD_MASTER_SUCCESS';
export const FETCH_CUTTING_DC_INWARD_MASTER_FAILURE = 'FETCH_CUTTING_DC_INWARD_MASTER_FAILURE';

// CREATE CUTTING INWARD_DC
export const CREATE_CUTTING_DC_INWARD_MASTER_REQUEST = 'CREATE_CUTTING_DC_INWARD_MASTER_REQUEST';
export const CREATE_CUTTING_DC_INWARD_MASTER_SUCCESS = 'CREATE_CUTTING_DC_INWARD_MASTER_SUCCESS';
export const CREATE_CUTTING_DC_INWARD_MASTER_FAILURE = 'CREATE_CUTTING_DC_INWARD_MASTER_FAILURE';

// UPDATE CUTTING INWARD_DC
export const UPDATE_CUTTING_DC_INWARD_MASTER_REQUEST = 'UPDATE_CUTTING_DC_INWARD_MASTER_REQUEST';
export const UPDATE_CUTTING_DC_INWARD_MASTER_SUCCESS = 'UPDATE_CUTTING_DC_INWARD_MASTER_SUCCESS';
export const UPDATE_CUTTING_DC_INWARD_MASTER_FAILURE = 'UPDATE_CUTTING_DC_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF CUTTING INWARD_DC
export const FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_FAILURE';

// DELETE CUTTING INWARD_DC
export const DELETE_CUTTING_DC_INWARD_MASTER_REQUEST = 'DELETE_CUTTING_DC_INWARD_MASTER_REQUEST';
export const DELETE_CUTTING_DC_INWARD_MASTER_SUCCESS = 'DELETE_CUTTING_DC_INWARD_MASTER_SUCCESS';
export const DELETE_CUTTING_DC_INWARD_MASTER_FAILURE = 'DELETE_CUTTING_DC_INWARD_MASTER_FAILURE';

export const FETCH_PENDING_CUTTING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_CUTTING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_CUTTING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_CUTTING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_CUTTING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_CUTTING_PO_IN_INWARD_FAILURE';

export const RESET_CUTTING_DC_INWARD_MASTER_INFO = 'RESET_CUTTING_DC_INWARD_MASTER_INFO';

export const CREATE_CUTTING_DC_INWARD_MASTER_FORM = 'CREATE_CUTTING_DC_INWARD_MASTER_FORM';

export const UPDATE_CUTTING_DC_INWARD_MASTER_FORM = 'UPDATE_CUTTING_DC_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_CUTTING_DC_INWARD_DETAILS = 'NAVIGATE_CUTTING_DC_INWARD_DETAILS';

// NAVIGATE TO CUTTING INWARD_DC COMPONENT
export const NAVIGATE_CUTTING_DC_INWARD_MASTER = 'NAVIGATE_CUTTING_DC_INWARD_MASTER';

export const RESET_FORM_DATA_WITHOUT_CUTTING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_CUTTING_INWARD_ID';
export const SET_ACTIVE_KEY_CUTTING_INWARD = 'SET_ACTIVE_KEY_CUTTING_INWARD';

export const SET_UNIT_NAME_CUTTING_DC_INWARD = 'SET_UNIT_NAME_CUTTING_DC_INWARD';
export const SET_START_DATE_CUTTING_DC_INWARD = 'SET_START_DATE_CUTTING_DC_INWARD';
export const SET_END_DATE_CUTTING_DC_INWARD = 'SET_END_DATE_CUTTING_DC_INWARD';

